import { publicEnv } from '@/config/public-env.config.mjs';
import { InsurancePackageType } from '@/types/booking';

export const assetPrefix =
  publicEnv.NEXT_PUBLIC_DOMAIN === 'localhost'
    ? ''
    : (publicEnv.NEXT_PUBLIC_ASSET_PREFIX ?? '/v3');

export const DEFAULT_MAX_STOP_POINTS = 10;
export const DEFAULT_MAX_STOP_INTERCITY = 1;
export const DEFAULT_MAX_STOP_HM = 1;

export enum ActionIndexPath {
  AddMoreBtn = -2,
  ShowInput = -1,
  Pickup = 0,
  ListDropoffBtn = 1, // or any positive integer value > 0
}

export const PAGE_INDEX = 0;
export const PAGE_SIZE = 30;

export const PATH_NUMBER_HAVE_PICKUP = 1;

export const PATH_NUMBER_CAN_ESTIMATE = 2; // include 1 pickup and 1 dropoff

export const COOKIE_NAME___ADD_BANK_ACCOUNT_POPUP = 'a_b_a_popup';
export const SESSION_STORAGE_ORDER_ID_LATEST_CREATED =
  'order_id_latest_created';

export const INVALID_PROMOTION_CREATE = 'PROMO_CODE_NOT_VALID';
export const INVALID_PROMOTION = 'INVALID_PROMOTION';
export const EXCEEDED_DISCOUNT_LIMIT = 'PROMO_CODE_EXCEEDED_DISCOUNT_LIMIT';
export const SERVICE_CONDITION_NOT_MET = 'SERVICE_CONDITION_NOT_MET';
export const INVALID_MAX_DISTANCE = 'INVALID_MAX_DISTANCE';
export const DEFAULT_COUNTRY_ID = 84;

export const USER_TYPE = {
  INDIVIDUAL: 'Individual',
  SME: 'SMEs',
  CORPORATION: 'Corporation',
};

export const STATUS_VERIFY_EKYC = {
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  IN_REVIEW: 'IN_REVIEW',
};

export const VERIFY_ACCOUNT_STATUS = {
  APPROVED_ID: 'APPROVED_ID',
  SUBMITTED: 'SUBMITTED',
  COMPLETED: 'COMPLETED',
  REJECT: 'REJECT',
};

export const MAX_ITEM_VALUE_DEFAULT = {
  TRUCK: 100000000,
  BIKE: 30000000,
};

export const ORDER_STATUS = {
  ALL: 'Tất cả',
  ASSIGNING: 'Đang tìm',
  IDLE: 'Đang chờ',
  ACCEPTED: 'Đã nhận',
  IN_PROCESS: 'Đang giao',
  COMPLETED: 'Hoàn thành',
  CANCELLED: 'Đã huỷ',
  FAILED: 'Giao thất bại',
  PAYING: 'Chờ thanh toán',
  CONFIRMING: 'Chờ xác nhận',
};

export interface InsuranceOption {
  id: string;
  name: string;
  description: string;
  from?: number;
  to?: number;
  price?: number;
  compensation?: number;
}

export const insuranceOptionsBike: InsuranceOption[] = [
  {
    id: InsurancePackageType.Basic,
    name: 'Gói Tiêu chuẩn',
    description: 'Mức bồi thường tối đa lên đến 5.000.000đ',
    from: 0,
    to: 5000001,
    price: 1000,
    compensation: 5000000,
  },
  {
    id: InsurancePackageType.Advanced,
    name: 'Gói Nâng cao',
    description: 'Mức bồi thường tối đa lên đến 10.000.000đ',
    from: 5000001,
    to: 10000001,
    price: 2000,
    compensation: 10000000,
  },
  {
    id: InsurancePackageType.Vip,
    name: 'Gói Cao cấp',
    description: 'Mức bồi thường tối đa lên đến 30.000.000đ',
    from: 10000001,
    to: 30000001,
    price: 10000,
    compensation: 30000000,
  },
  {
    id: InsurancePackageType.None,
    name: 'Không khai giá hàng hóa',
    description:
      'Áp dụng chính sách bồi thường cho đơn hàng không sử dụng dịch vụ khai giá.',
  },
];

export const insuranceOptionsTruck: InsuranceOption[] = [
  {
    id: InsurancePackageType.Basic,
    name: 'Gói Tiêu chuẩn',
    description: 'Mức bồi thường tối đa lên đến 10.000.000đ',
    from: 0,
    to: 10000001,
    price: 2000,
    compensation: 10000000,
  },
  {
    id: InsurancePackageType.Advanced,
    name: 'Gói Nâng cao',
    description: 'Mức bồi thường tối đa lên đến 30.000.000đ',
    from: 10000001,
    to: 30000001,
    price: 10000,
    compensation: 30000000,
  },
  {
    id: InsurancePackageType.Vip,
    name: 'Gói Cao cấp',
    description: 'Mức bồi thường tối đa lên đến 50.000.000đ',
    from: 30000001,
    to: 50000001,
    price: 20000,
    compensation: 50000000,
  },
  {
    id: InsurancePackageType.Corporation,
    name: 'Gói Doanh nghiệp',
    description: 'Mức bồi thường tối đa lên đến 100.000.000đ',
    from: 50000001,
    to: 100000001,
    price: 40000,
    compensation: 100000000,
  },
  {
    id: InsurancePackageType.None,
    name: 'Không khai giá hàng hóa',
    description:
      'Áp dụng chính sách bồi thường cho đơn hàng không sử dụng dịch vụ khai giá.',
  },
];
export const MAX_NUMBER_OF_USER_PLACE = 50;
export const MAX_STOP_POINTS_SHOW_ENTRANCE_RO = 6;

export const SPECIAL_TAGS = {
  SME_RO: 'SME_RO',
};

export const ESTIMATE_FEE_ACCEPTS_VERSION = 6;

export const ORDER_CANCEL_ACTION_TYPE = {
  REORDER: 'reorder',
  REBROADCAST: 'rebroadcast',
  CHANGE_INFO: 'change_info', // at mobile app have screen change info | web support to avoid confusion
  CANCEL: 'cancel',
};

export enum CheckoutType {
  Subscription = 'subscription',
  Topup = 'top-up',
  Order = 'order',
  Reimbursement = 'reimbursement',
  Pod = 'pod',
  Tip = 'tip',
  Aharent = 'aharent',
}

export enum TIP_TYPE {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE',
}

export const RATING_VISIBLE_DURATION = 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds

export const WEB_IN_APP_AHAMOVE_ID = 'ahamove';
export const WEB_IN_APP_MOMO_ID = 'momo_deeplink';
export const WEB_IN_APP_MOMO_MINIAPP = 'momo_permission';
export const WEB_IN_APP_ZALO_ID = 'zalo';
export const WEB_IN_APP_ZALOPAY_ID = 'zalopay';
// export const WEB_IN_APP_SMARTPAY_ID = 'smartpay_deeplink'
export const WEB_IN_APP_VIETTELPAY_ID = 'viettel-pay_deeplink';
export const WEB_IN_APP_VIETTEL_APP_ID = 'VIETTEL';
export const WEB_IN_APP_SHOPEEPAY_ID = 'shopee-pay_deeplink';
export const WEB_IN_APP_ONWHEEL_ID = 'onwheel';
// export const WEB_IN_APP_VPBANK_ID = 'vpbank_deeplink'
export const WEB_IN_APP_AHAUSER_ID = 'ahauser';
export const WEB_IN_APP_AHADRIVER_ID = 'ahadriver';
export const HEADER_NAME__WEB_IN_APP = 'WebInApp';

export const REMOTE_CONFIG_KEY = {
  SURGE_PRICE_DISPLAY_CONFIG: 'surge_price_display_config',
  USER_ENABLE_PASSCODE: 'user_enable_passcode',
  ENABLE_HOME_PAGE: 'enable_homepage_web',
  USER_UPDATE_CATEGORY_REWARD_POINT: 'user_update_category_reward_point',
  USER_USE_EKYC: 'user_use_ekyc',
  EKYC_PROVIDER: 'ekyc_provider',
  USER_TIPS_DEADLINE_SEC: 'user_tips_deadline_sec',
  USER_REIMBURSEMENT_DEADLINE_SEC: 'user_reimbursement_deadline_sec',
  CHAT_DURATION: 'chat_duration',
};

export const SERVICE_HAVE_HUB_SP_TRANSFER_COD_REQUEST = [
  'SGN-HUB-SP',
  'SGN-TMDT',
  'SGN-HUB-SP-14H',
  'HAN-HUB',
  'HAN-HUB-13',
  'HAN-TMDT',
  'SGN-HUB-SE',
];

export const SUPPLIER_RANKING_VISIBLE = {
  PROFESSIONAL: 'PROFESSIONAL',
  SUPER: 'SUPER',
};

export const RECORDS_LIST_STATUS = {
  ALL: 'ALL',
  CONFIRMING: 'CONFIRMING',
  PAYING: 'PAYING',
  IDLE: 'IDLE',
  ASSIGNING: 'ASSIGNING',
  ACCEPTED: 'ACCEPTED',
  IN_PROCESS: 'IN_PROCESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  // FAILED: 'FAILED',
};

export const ORDER_STATUS_COLORS: Record<
  string,
  { color: string; bg: string }
> = {
  CONFIRMING: { color: 'blue.6', bg: 'blue.0' },
  PAYING: { color: 'yellow.7', bg: 'yellow.0' },
  IDLE: { color: 'neutral.6', bg: 'neutral.1' },
  ASSIGNING: { color: 'blue.6', bg: 'blue.0' },
  ACCEPTED: { color: 'blue.6', bg: 'blue.0' },
  IN_PROCESS: { color: 'blue.6', bg: 'blue.0' },
  COMPLETED: { color: 'green.6', bg: 'green.0' },
  CANCELLED: { color: 'neutral.6', bg: 'neutral.1' },
  FAILED: { color: 'red.6', bg: 'red.0' },
  IN_RETURN: { color: 'blue.6', bg: 'blue.0' },
  ALL: { color: 'neutral.6', bg: 'neutral.1' },
};
